
import { Link } from "react-router-dom"

export default function Course2() {
	return (
		<>

			<div className="tf-widget-course main-content-medium background-black">
				<div className="themeflat-container">
					<div className="tf-course">
						{/* header style v2 */}
						<div className="title-box-v2 center-title-box title-large">
							<span className="sub-title wow fadeInUp animated">Course/tutorial</span>
							<h2 className="title-section wow fadeInUp animated">Running Course articles &amp; video<br /> tutorials about
								running</h2>
						</div>{/* header style v2 */}
						<div className="row">
							<div className="col-md-4 course">
								<div className="course-item-wrap course-text wow fadeInUp animated" data-wow-delay="0.1s">
									<div className="image-course">
										<span className="date-course">21 Oct</span>
										<img src="images/retinal/tutorial1.jpg" alt="" />
									</div>
									<div className="content-course">
										<div className="meta-course">
											<ul>
												<li>
													<Link to="/blog-single">
														<svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clipPath="url(#clip0_6730_10359)">
																<path d="M3.96938 13.1725C3.82899 13.032 3.75009 12.8415 3.75 12.6428V3.95312H12.4397C12.6383 3.95322 12.8288 4.03211 12.9694 4.1725L22.2806 13.4838C22.4212 13.6244 22.5001 13.8151 22.5001 14.0139C22.5001 14.2127 22.4212 14.4034 22.2806 14.5441L14.3438 22.4838C14.2031 22.6243 14.0124 22.7032 13.8136 22.7032C13.6148 22.7032 13.4241 22.6243 13.2834 22.4838L3.96938 13.1725Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
																<path d="M8.25 8.07812C8.25 8.28523 8.08211 8.45312 7.875 8.45312C7.66789 8.45312 7.5 8.28523 7.5 8.07812C7.5 7.87102 7.66789 7.70312 7.875 7.70312C8.08211 7.70312 8.25 7.87102 8.25 8.07812Z" stroke="white" strokeWidth="1.5" />
															</g>
														</svg>
														Running Tips
													</Link>
													<Link to="/blog-single">
														<svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clipPath="url(#clip0_6730_10365)">
																<path d="M6.71063 13.7031L3 16.7031V4.70312C3 4.50421 3.07902 4.31345 3.21967 4.1728C3.36032 4.03214 3.55109 3.95312 3.75 3.95313H15.75C15.9489 3.95313 16.1397 4.03214 16.2803 4.1728C16.421 4.31345 16.5 4.50421 16.5 4.70312V12.9531C16.5 13.152 16.421 13.3428 16.2803 13.4835C16.1397 13.6241 15.9489 13.7031 15.75 13.7031H6.71063Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
																<path d="M7.5 13.7031V17.4531C7.5 17.652 7.57902 17.8428 7.71967 17.9835C7.86032 18.1241 8.05109 18.2031 8.25 18.2031H17.2894L21 21.2031V9.20312C21 9.00421 20.921 8.81345 20.7803 8.6728C20.6397 8.53214 20.4489 8.45312 20.25 8.45312H16.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
															</g>
														</svg>
														12 comments
													</Link>
												</li>
											</ul>
										</div>
										<h5 className="title-course"><Link to="/blog-single">Embracing the Journey: Unraveling
											the Life-Changing
											Benefits of
											Running</Link></h5>
										<p className="description-course">Explore the myriad health advantages that running offers,
											from enhancing
											cardiovascular fitness and strengthening...</p>
									</div>
									<Link to="/blog-single" className="flat-button">Read more</Link>
								</div>
							</div>
							<div className="col-md-4 course">
								<div className="course-item-wrap course-text wow fadeInUp animated" data-wow-delay="0.3s">
									<div className="image-course">
										<span className="date-course">14 Oct</span>
										<img src="images/retinal/tutorial2.jpg" alt="" />
									</div>
									<div className="content-course">
										<div className="meta-course">
											<ul>
												<li>
													<Link to="/blog-single">
														<svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clipPath="url(#clip0_6730_10359)">
																<path d="M3.96938 13.1725C3.82899 13.032 3.75009 12.8415 3.75 12.6428V3.95312H12.4397C12.6383 3.95322 12.8288 4.03211 12.9694 4.1725L22.2806 13.4838C22.4212 13.6244 22.5001 13.8151 22.5001 14.0139C22.5001 14.2127 22.4212 14.4034 22.2806 14.5441L14.3438 22.4838C14.2031 22.6243 14.0124 22.7032 13.8136 22.7032C13.6148 22.7032 13.4241 22.6243 13.2834 22.4838L3.96938 13.1725Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
																<path d="M8.25 8.07812C8.25 8.28523 8.08211 8.45312 7.875 8.45312C7.66789 8.45312 7.5 8.28523 7.5 8.07812C7.5 7.87102 7.66789 7.70312 7.875 7.70312C8.08211 7.70312 8.25 7.87102 8.25 8.07812Z" stroke="white" strokeWidth="1.5" />
															</g>
														</svg>
														Training Programs
													</Link>
													<Link to="/blog-single">
														<svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clipPath="url(#clip0_6730_10365)">
																<path d="M6.71063 13.7031L3 16.7031V4.70312C3 4.50421 3.07902 4.31345 3.21967 4.1728C3.36032 4.03214 3.55109 3.95312 3.75 3.95313H15.75C15.9489 3.95313 16.1397 4.03214 16.2803 4.1728C16.421 4.31345 16.5 4.50421 16.5 4.70312V12.9531C16.5 13.152 16.421 13.3428 16.2803 13.4835C16.1397 13.6241 15.9489 13.7031 15.75 13.7031H6.71063Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
																<path d="M7.5 13.7031V17.4531C7.5 17.652 7.57902 17.8428 7.71967 17.9835C7.86032 18.1241 8.05109 18.2031 8.25 18.2031H17.2894L21 21.2031V9.20312C21 9.00421 20.921 8.81345 20.7803 8.6728C20.6397 8.53214 20.4489 8.45312 20.25 8.45312H16.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
															</g>
														</svg>
														2 comments
													</Link>
												</li>
											</ul>
										</div>
										<h5 className="title-course"><Link to="/blog-single">Empowerment through Running:
											Discovering the Key to
											a Healthier and Happier Life</Link></h5>
										<p className="description-course">Unleash the freedom of mind and body as you experience the
											joy and liberation of running. Discover how running...</p>
									</div>
									<Link to="/blog-single" className="flat-button">Read more</Link>
								</div>
							</div>
							<div className="col-md-4 course">
								<div className="course-item-wrap course-text wow fadeInUp animated" data-wow-delay="0.5s">
									<div className="image-course">
										<span className="date-course">25 Oct</span>
										<img src="images/retinal/tutorial3.jpg" alt="" />
									</div>
									<div className="content-course">
										<div className="meta-course">
											<ul>
												<li>
													<Link to="/blog-single">
														<svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clipPath="url(#clip0_6730_10359)">
																<path d="M3.96938 13.1725C3.82899 13.032 3.75009 12.8415 3.75 12.6428V3.95312H12.4397C12.6383 3.95322 12.8288 4.03211 12.9694 4.1725L22.2806 13.4838C22.4212 13.6244 22.5001 13.8151 22.5001 14.0139C22.5001 14.2127 22.4212 14.4034 22.2806 14.5441L14.3438 22.4838C14.2031 22.6243 14.0124 22.7032 13.8136 22.7032C13.6148 22.7032 13.4241 22.6243 13.2834 22.4838L3.96938 13.1725Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
																<path d="M8.25 8.07812C8.25 8.28523 8.08211 8.45312 7.875 8.45312C7.66789 8.45312 7.5 8.28523 7.5 8.07812C7.5 7.87102 7.66789 7.70312 7.875 7.70312C8.08211 7.70312 8.25 7.87102 8.25 8.07812Z" stroke="white" strokeWidth="1.5" />
															</g>
														</svg>
														Running Events
													</Link>
													<Link to="/blog-single">
														<svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clipPath="url(#clip0_6730_10365)">
																<path d="M6.71063 13.7031L3 16.7031V4.70312C3 4.50421 3.07902 4.31345 3.21967 4.1728C3.36032 4.03214 3.55109 3.95312 3.75 3.95313H15.75C15.9489 3.95313 16.1397 4.03214 16.2803 4.1728C16.421 4.31345 16.5 4.50421 16.5 4.70312V12.9531C16.5 13.152 16.421 13.3428 16.2803 13.4835C16.1397 13.6241 15.9489 13.7031 15.75 13.7031H6.71063Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
																<path d="M7.5 13.7031V17.4531C7.5 17.652 7.57902 17.8428 7.71967 17.9835C7.86032 18.1241 8.05109 18.2031 8.25 18.2031H17.2894L21 21.2031V9.20312C21 9.00421 20.921 8.81345 20.7803 8.6728C20.6397 8.53214 20.4489 8.45312 20.25 8.45312H16.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
															</g>
														</svg>
														09 comments
													</Link>
												</li>
											</ul>
										</div>
										<h5 className="title-course"><Link to="/blog-single">Running towards Greatness: Unleash
											Your Inner
											Athlete and Embrace the Joy of Fitness</Link></h5>
										<p className="description-course">Embrace the camaraderie and support of the running
											community as you connect with like-minded individuals...</p>
									</div>
									<Link to="/blog-single" className="flat-button">Read more</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
